import { assign } from "lodash-es";
export default function adjustRangeToInsert(rangeToBeAdjusted, insertStart, insertLength) {
  const newRange = assign({}, rangeToBeAdjusted);
  if (rangeToBeAdjusted.start > rangeToBeAdjusted.end) {
    if (rangeToBeAdjusted.end >= insertStart) {
      newRange.start += insertLength;
      newRange.end += insertLength;
    } else if (rangeToBeAdjusted.start >= insertStart) {
      newRange.start += insertLength;
    }
  } else {
    if (rangeToBeAdjusted.start >= insertStart) {
      newRange.start += insertLength;
      newRange.end += insertLength;
    } else if (rangeToBeAdjusted.end >= insertStart) {
      newRange.end += insertLength;
    }
  }
  return newRange;
}
